import { defineComponent as _defineComponent } from 'vue'
import { Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { useRoute } from 'vue-router';


import Toasts from '@/components/Toasts.vue';
import HeaderMyPage from '@/components/HeaderMyPage.vue';
import HeaderLogin from '@/components/HeaderLogin.vue';
import FooterMyPage from './components/FooterMyPage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const arrInclude = ['JobSearchView', 'JobSearchPublicView', 'PendingView', 'ApplyView', 'ApplyClosedView', 'RefusalListView', 'VideoListView'];

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$route.name === null || _ctx.$route.name === undefined || _ctx.$route.meta.header === 'none')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
      : (_unref(route).meta.header === 'login')
        ? (_openBlock(), _createBlock(HeaderLogin, { key: 1 }))
        : (_openBlock(), _createBlock(HeaderMyPage, { key: 2 })),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({Component}) => [
        (_openBlock(), _createBlock(_KeepAlive, { include: arrInclude }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1024))
      ]),
      _: 1
    }),
    (_ctx.$route.name === null || _ctx.$route.name === undefined || _ctx.$route.meta.footer === 'none')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [], 64))
      : (_unref(route).meta.footer && _unref(route).meta.footer != 'none')
        ? (_openBlock(), _createBlock(FooterMyPage, { key: 4 }))
        : _createCommentVNode("", true),
    _createVNode(Toasts)
  ], 64))
}
}

})